// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/finito-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import baoRouter from "./../services/bao-router";
import SubscriptionViewModel from "./../factories/subscription-view-model";
import finitoService from "../services/finito-service";
class InstructionkBook extends SubscriptionViewModel {
    FormName: KnockoutObservable<string> = ko.observable();
    ReportShortTitle: KnockoutObservable<string> = ko.observable();
    ReportTitle: KnockoutObservable<string> = ko.observable();
    InstructionBooks: KnockoutObservableArray<any> = ko.observableArray([]);
    SelectedInstructionBookId: KnockoutObservable<string> = ko.observable();
    ShowAll: KnockoutObservable<boolean> = ko.observable();
    ShowClosedInstructions: KnockoutObservable<boolean> = ko.observable();
    OnlyShowUnread: KnockoutObservable<boolean> = ko.observable();
    Instructions: KnockoutObservableArray<any> = ko.observableArray([]);
    PageSize: KnockoutObservable<number> = ko.observable(20);
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    Sorting: KnockoutObservableArray<any> = ko.observableArray();
    Selection: KnockoutObservableArray<any> = ko.observableArray();
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    CustomFilter: KnockoutObservable<any> = ko.observable({});
    IsFirstLoaded: KnockoutObservable<boolean> = ko.observable(false);
    IsAutomaticReadWorkflowEnabled: KnockoutObservable<boolean> = ko.observable(false);
    ShiftbooksPermissions: any;
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    Color: string = "text-danger";
    Icon: string = "fal fa-exclamation-triangle";
    Sort: number = 30;
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SettingsKeyPermission("ShiftbookSave");
        this.SettingsKeyPermissionApplicationId(window.FinitoApplicationId);
        this.subscribe(this.PageIndex, () => {
            if (this.IsFirstLoaded()) {
                this.RefreshInstructions();
            }
        });
        this.subscribe(this.SelectedInstructionBookId, () => {
            this.SetPermissions();
            this.RefreshInstructions();
            this.isQuickStartModuleActive();
            baoRouter.setHash("instructionbook/" + this.SelectedInstructionBookId());
            this.SettingsUrl(this.SelectedInstructionBookId() ? 'Shiftbook/' + this.SelectedInstructionBookId() : null);       
        });
        this.subscribe(this.TotalRows, () => {
            this.toggleButtons();
        });
        this.subscribe(this.TabPage.UrlData, (value) => {
            if (value.instructionbookid && this.SelectedInstructionBookId() != value.instructionbookid && this.InstructionBooks().some(b => ko.unwrap(b.ShiftbookId) == value.instructionbookid)) {
                this.SelectedInstructionBookId(value.instructionbookid)
            }
        });
    }
    link = (index, instructionModel) => {
        let linkHash = 'instruction/' + instructionModel.InstructionId();
        baoRouter.setHash(linkHash);
    };
    init = () => {
        this.TabPage.IsLoading(true);
        return $.when(this.getUserProfile(), this.getInstructionBooks()).then(() => {
            return this.getReport()
                // abschließend sicher stellen, dass die Buttons den richtigen State haben
                .then(() => {
                this.toggleButtons();
                this.SetPermissions();
            });
        });
    };
    loaded = () => {
        let def = $.Deferred();
        this.registerMenuClick();
        this.toggleButtons();
        Bao.bindEvent('instructions:refresh', (value) => {
            this.refresh();
        });
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        this.subscribe(this.Selection, () => {
            this.toggleButtons();
        });
        this.subscribe(this.Sorting, () => {
            this.RefreshInstructions();
        });
        this.subscribe(this.CustomFilter, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.ShowClosedInstructions, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.OnlyShowUnread, () => {
            this.ResetPageIndexAndRefresh();
        });
        this.subscribe(this.PageSize, () => {
            this.ResetPageIndexAndRefresh();
        });
     
        def.resolve();
        return def.promise();
    };
    ToHashObject = (customFilter) => {
        let returnValue = [];
        for (let f in customFilter) {
            returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    };
    // Fetch UserProfile
    getUserProfile = () => {
        return Bao.post('InstructionBook/LoadUserProfile', JSON.stringify({})).then((result) => {
            this.ShowClosedInstructions(result.showClosed === "true" ? true : false);
            this.OnlyShowUnread(result.onlyShowUnread === "true" ? true : false);
        });
    };
    getInstructionBooks = () => {
        return Bao.post('Shiftbook/GetInstructionBooksForCurrentUser')
            .then(serverResult => {
            if (serverResult && serverResult.BooksForCurrentUser && serverResult.BooksForCurrentUser.length > 0) {
                this.InstructionBooks(serverResult.BooksForCurrentUser);
                this.ShiftbooksPermissions = serverResult.ShiftbooksPermissions;
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgUserHasNoAssignedInstructionBooks"), "info");
                this.TabPage.IsLoading(false);
            }
            let instructionBookId = baoRouter.getRouteValue("instructionbookid", (<any>this.TabPage));
            if (instructionBookId && serverResult.BooksForCurrentUser.filter(t => t.ShiftbookId === instructionBookId).length > 0) {
                this.SelectedInstructionBookId(instructionBookId);
            }
        });
    };
    //
    // Menü-ClickHandler
    registerMenuClick = () => {
        BaoMenu.registerEvent((btn) => {
            if (this.TabPage != null && this.TabPage.IsActiveTab != null && this.TabPage.IsActiveTab() === true) {
                let methodString = btn.ActionKey().substr(this.FormName().length);
                if (methodString) {
                    methodString = methodString.toLowerCase();
                    if ($.isFunction(this[methodString])) {
                        if (methodString === "refresh") {
                            this.RefreshInstructions();
                        }
                        else {
                            this[methodString]();
                        }
                    }
                }
            }
        });
    };
    //
    // Fetch Report
    getReport = () => {
        return Bao.post('InstructionBook/GetInstructionBookModel', JSON.stringify({})).then((result) => {
            ko.map.fromJS(result.Model, this);
            this.TabPage.Title(this.ReportShortTitle());
            (<any>this.TabPage).ToolTip(this.ReportTitle());
        });
    };
    /** calls getInstructions and handles IsLoading */
    RefreshInstructions() {
        this.TabPage.IsLoading(true);
        this.getInstructions()
            .then(() => {
            this.TabPage.IsLoading(false);
        });
    }
    //
    // Fetch Instructions
    getInstructions = () => {
        if (!this.SelectedInstructionBookId())
            return $.Deferred().resolve().promise();
        let customFilter = this.ToHashObject(ko.unwrap(this.CustomFilter));
        return Bao.post('InstructionBook/GetAll', JSON.stringify({
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            searchFilter: {
                ShowAll: this.ShowAll(),
                ShowClosed: this.ShowClosedInstructions(),
                ShowOnlyUnread: this.OnlyShowUnread(),
                ShiftbookIds: [this.SelectedInstructionBookId()]
            },
            customfilter: customFilter
        })).then((result) => {
            ko.map.fromJS(result.Models, this.Instructions);
            this.TotalRows(result.TotalRows);
            this.IsFirstLoaded(true);
        });
    };
    //
    // Buttons ein-/ausblenden
    toggleButtons = () => {
        if (this.FormName) {
            if (this.SelectedInstructionBookId()) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: true, Context: this.TabPage.Context() });
            }
            else {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'New', Enabled: false, Context: this.TabPage.Context() });
            }
            if (this.TotalRows && this.TotalRows() < 1) {
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: false, Context: this.TabPage.Context() });
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: false, Context: this.TabPage.Context() });
            }
            else {
                var selection = this.Selection.peek();
                BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Print', Enabled: true, Context: this.TabPage.Context() });
                if (selection && selection.length > 0) {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: true, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: true, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: this.canFinish(selection[0]), Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: !selection[0].IsRead.peek() && selection[0].CanMarkRead() && !selection[0].IsClosed.peek() && selection[0].IsInstructionValid() && selection[0].CanEditBasedOnApproval.peek(), Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: this.canApprove(selection[0]), Context: this.TabPage.Context() });
                }
                else {
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Edit', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Delete', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Finish', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Read', Enabled: false, Context: this.TabPage.Context() });
                    BaoMenu.permissionEnable({ ActionKey: this.FormName() + 'Approve', Enabled: false, Context: this.TabPage.Context() });
                }
            }
        }
    };
    //
    // Anweisung erstellen
    ["new"] = () => {
        var linkHash = 'instruction/' + Guid() + '/' + this.SelectedInstructionBookId();
        baoRouter.setHash(linkHash);
    };
    //
    // Anweisung bearbeiten
    edit = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            baoRouter.setHash('instruction/' + selection[0].InstructionId());
        }
    };
    //
    // Anweisung erledigen
    finish = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionFinishQuestion), 'yesno');
            dialog.DialogResult.subscribe(shouldFinish => {
                if (shouldFinish) {
                    this.TabPage.IsLoading(true);
                    Bao.post('Instruction/Finish', JSON.stringify({
                        instructionIds: [selection[0].InstructionId()]
                    })).then(finished => {
                        if (finished > 0) {
                            this.refresh();
                        }
                        else {
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    //Anweisung genehmigen
    approve = () => {
        var selection = this.Selection();
        return Bao.post("Instruction/InstructionApprovalDialog", JSON.stringify({}), result => {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            dialog.ViewModel(self);
            var approveButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgApprove"), () => {
                this.TabPage.IsLoading(true);
                Bao.post('Instruction/Approve', JSON.stringify({
                    instructionId: selection[0].InstructionId()
                })).then(approved => {
                    if (approved > 0) {
                        this.showAlert(finitoService.MessageKeys.InstructionApproveSuccessful);
                        this.refresh();
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.InstructionApproveError, 'info');
                    }
                    this.TabPage.IsLoading(false);
                });
                dialog.Close();
            });
            var rejectButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgReject"), () => {
                this.TabPage.IsLoading(true);
                Bao.post('Instruction/Reject', JSON.stringify({
                    instructionId: selection[0].InstructionId()
                })).then(rejected => {
                    if (rejected > 0) {
                        this.showAlert(finitoService.MessageKeys.InstructionRejectSuccessful);
                        this.refresh();
                    }
                    else {
                        this.showAlert(finitoService.MessageKeys.InstructionRejectError, 'info');
                    }
                    this.TabPage.IsLoading(false);
                });
                dialog.Close();
            });
            var cancelButton = new BaoDialogViewModel.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            dialog.Buttons([approveButton, rejectButton, cancelButton]);
            dialog.Template(result.Template);
            dialog.Open();
        });
    };
    canFinish = (instruction) => {
        if (instruction) {
            if (!instruction.IsClosed.peek() && instruction.CanEditBasedOnApproval.peek()) {
                if (instruction.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidToFinished
                    || instruction.InstructionTypeId.peek() === finitoService.InstructionTypeIds.ValidFromToOrFinished) {
                    return true;
                }
            }
        }
        return false;
    };
    canApprove = (instruction) => {
        if (instruction) {
            if (!instruction.IsClosed.peek()) {
                if (instruction.IsApprover.peek() && instruction.IsWaitForApproval.peek()) {
                    return true;
                }
            }
        }
        return false;
    };
    //
    // Anweisung als gelesen markieren
    read = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionReadQuestion), 'yesno');
            dialog.DialogResult.subscribe(shouldRead => {
                if (shouldRead) {
                    this.TabPage.IsLoading(true);
                    Bao.post('Instruction/Read', JSON.stringify({
                        instructionIds: [selection[0].InstructionId()]
                    })).then(read => {
                        if (read > 0) {
                            this.refresh();
                        }
                        else {
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    //
    // Aufgabe löschen
    ["delete"] = () => {
        var selection = this.Selection();
        if (selection && selection.length > 0) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage(finitoService.MessageKeys.InstructionDeleteQuestion), 'yesno');
            dialog.DialogResult.subscribe(canDelete => {
                if (canDelete) {
                    this.TabPage.IsLoading(true);
                    return Bao.post('Instruction/Delete', JSON.stringify({
                        instructionIds: [selection[0].InstructionId()]
                    })).then(deleted => {
                        this.Selection([]);
                        if (deleted > 0) {
                            this.showAlert(finitoService.MessageKeys.InstructionDeleteSuccessful);
                            this.refresh();
                        }
                        else {
                            this.showAlert(finitoService.MessageKeys.InstructionDeleteError, 'danger');
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    };
    //
    // Aktualisieren
    refresh = () => {
        this.getInstructions();
    };
    //
    // Drucken
    print = () => {
        this.TabPage.IsLoading(true);
        Bao.post("InstructionBook/Print", JSON.stringify({
            showClosed: this.ShowClosedInstructions(),
            shiftbookId: this.SelectedInstructionBookId()
        }), result => {
            this.TabPage.IsLoading(false);
            if (result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            }
            else {
                new BaoDialogViewModel(Bao.Session.GetApplicationName(), result.Message, "info");
            }
        });
    };
    /**
     * Get the permissions object for the current selected instructionbook
     * */
    GetCurrentBooksPermissions() {
        if (this.SelectedInstructionBookId() && this.ShiftbooksPermissions) {
            return this.ShiftbooksPermissions[this.SelectedInstructionBookId()];
        }
        return null;
    }
    /**
     * Shows/Hides toolbarbuttons for the current taskbookpermissions (RoleShiftbooks)
     * */
    SetPermissions() {
        let permissions = this.GetCurrentBooksPermissions();
        if (!permissions)
            return;
        for (let actionKey in permissions) {
            BaoMenu.permissionVisible({ ActionKey: actionKey, Context: this.TabPage.Context(), Visible: permissions[actionKey] });
            if (actionKey === "InstructionReportShowAll") {
                this.ShowAll(permissions[actionKey]);
            }
        }
    }
    ResetPageIndexAndRefresh() {
        if (this.PageIndex() === 0) {
            this.RefreshInstructions();
        }
        else {
            this.PageIndex(0);
        }
    }
    ;
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        var selectedinstructionBooks = this.InstructionBooks().
            filter(e => e.PrimaryKeyValue === this.SelectedInstructionBookId());
        var instructionBookName = selectedinstructionBooks[0].Name;
        var instructionBookCssClass = selectedinstructionBooks[0].CssClass;
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: instructionBookName,
            caption2: instructionBookName,
            caption3: instructionBookName,
            caption4: instructionBookName,
            caption5: instructionBookName,
            webUrl: this.GetInstructionBookDeepLink(),
            color: this.Color,
            icon: (typeof instructionBookCssClass != 'undefined' && instructionBookCssClass) ? instructionBookCssClass : this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                this.IsFavorite(true);
            }
            this.TabPage.IsLoading(false);
        });
    };
    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetInstructionBookDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetInstructionBookDeepLink()
        })).done(result => {
            if (result) {
                this.IsFavorite(false);
            }
            this.TabPage.IsLoading(false);
        });
    };
    GetInstructionBookDeepLink() {
        return "#/InstructionBook/" + this.SelectedInstructionBookId();
    }
}
export default InstructionkBook;